// Shared gradient palette used for daily-quote cards and auto-generated
// workout summary images (when a post has no uploaded photo).
export const GRADIENTS = [
  { bg: "linear-gradient(135deg,#667eea,#764ba2)", text: "#fff" },
  { bg: "linear-gradient(135deg,#f093fb,#f5576c)", text: "#fff" },
  { bg: "linear-gradient(135deg,#4facfe,#00f2fe)", text: "#fff" },
  { bg: "linear-gradient(135deg,#43e97b,#38f9d7)", text: "#1a3a2a" },
  { bg: "linear-gradient(135deg,#fa709a,#fee140)", text: "#3a1a00" },
  { bg: "linear-gradient(135deg,#a18cd1,#fbc2eb)", text: "#2a1040" },
  { bg: "linear-gradient(135deg,#f6d365,#fda085)", text: "#3a1a00" },
  { bg: "linear-gradient(135deg,#89f7fe,#66a6ff)", text: "#0a1040" },
  { bg: "linear-gradient(135deg,#d4fc79,#96e6a1)", text: "#1a3a1a" },
  { bg: "linear-gradient(135deg,#fddb92,#d1fdff)", text: "#1a2a3a" },
];

export const getDailyIndex = (arr, seed = new Date()) => {
  const dayOfYear = Math.floor(
    (seed - new Date(seed.getFullYear(), 0, 0)) / 86_400_000,
  );
  return dayOfYear % arr.length;
};

// Deterministic gradient pick for a stable id (e.g. a post id) rather than
// the day-of-year — used so a given post's fallback image doesn't change
// on every render/refetch.
export const getGradientForId = (id) => {
  const str = String(id);
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return GRADIENTS[hash % GRADIENTS.length];
};
